
import { atomWithStorage } from 'jotai/utils';

interface CategoryData {
  id: string;
  nameEnglish: string;
  nameArabic: string;
  status: 'blocked' | 'unblocked' | string;
  addedBy: string;
  storeId?: string;
  storeType?: string;
  [key: string]: any;
}

export const itemSubCategoryAtom = atomWithStorage<CategoryData | null>(
  'itemSubCategoryId',
  null
);

// Utility function to get initial page based on user type and permissions
export const getInitialPage = (userType: string, permissions: any): string => {
  // If not subadmin, redirect to dashboard (admin behavior)
  if (userType !== 'subAdmin') {
    return '/dashboard';
  }

  // If subadmin has privilege (full access), redirect to sub-admin list
  if (permissions?.privilege) {
    return '/dashboard';
  }

  // Check permissions in order of priority and return the first one with view permission
  const permissionModules = [
    { module: 'subAdmin', path: '/sub-admin/list' },
    { module: 'storeCategory', path: '/managecuisine' },
    { module: 'itemCategory', path: '/manageItemCategory' },
    { module: 'choiceGroup', path: '/manage-choice-group' },
    { module: 'choices', path: '/manage-choice' },
    { module: 'storeOwner', path: '/store-owner' },
    { module: 'store', path: '/manage-store' },
    { module: 'customer', path: '/manageCustomer' },
    { module: 'joinUs', path: '/join-us' },
    { module: 'item', path: '/manageStoreItem' },
    { module: 'deliveryManager', path: '/admin-delivery' },
    { module: 'deliveryBoy', path: '/delivery-boy' },
    { module: 'coupon', path: '/manageCoupon' },
    { module: 'cms', path: '/manage-CMS' },
    { module: 'faq', path: '/manage-FAQ' },
    { module: 'order', path: '/manageOrder' },
    { module: 'inventory', path: '/manageStock' },
    { module: 'settings', path: '/settings' },
  ];

  for (const { module, path } of permissionModules) {
    const modulePermissions = permissions?.[module];
    if (modulePermissions && typeof modulePermissions === 'object' && 'view' in modulePermissions) {
      if (modulePermissions.view === true) {
        return path;
      }
    }
  }

  // If no permissions found, redirect to sub-admin list as fallback
  return '/dashboard';
};
